// extracted by mini-css-extract-plugin
module.exports = {"root":"welcome_root__2mtAa","sidebar":"welcome_sidebar__2VgD4"};